import {
  REQUEST_FETCH_PASSENGERS,
  FETCH_PASSENGERS_SUCCESS,
  FETCH_PASSENGERS_ERROR,
} from "../../../actions/reservations/passenger/fetchPassengersByCruise";

const initialState = {
  passengers: [],
  fetching: false,
  message: "",
  error: "",
};

const passengerByCruiseReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FETCH_PASSENGERS: {
      return {
        ...state,
        passengers: [],
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_PASSENGERS_SUCCESS: {
      return {
        ...state,
        passengers: action.passengers,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case FETCH_PASSENGERS_ERROR: {
      return {
        ...state,
        passengers: [],
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};
export default passengerByCruiseReducer;
